import { render } from "./picture.svg?vue&type=template&id=9ea06200?inline"
const script = {}
script.render = render

export default script